<p-table
  [value]="data"
  [loading]="loading"
  [rows]="rows"
  [first]="first">
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width: 320px">Name</th>
      <th>#</th>
      <th>Chains</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>
        <p-button [label]="row.form_name" link="true" routerLink="/forms/builder/edit/{{row.id}}"/>
      </td>
      <td>{{ row.id }}</td>
      <td>
        <div class="flex-row flex-wrap gap-4px">
          @for (chain of row.chains; track chain.chain_id; let i = $index) {
            @if (i < 5) {
              <p-tag [value]="chain.name"/>
            }
          }
          @if (row.chains.length > 5) {
            <p-tag severity="secondary" [value]="'+' + (row.chains.length - 5) + ' more'"/>
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-paginator
  [rows]="rows"
  [totalRecords]="totalRecords"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  (onPageChange)="onPageChange($event)"
/>
